export const ERROR = {
  GT_ZERO: 'Must be greater than zero',
  REQUIRED: 'This field is required',
  UNSUPPORTED_FORMAT: 'The file chosen is an unsupported format',
  VALID_DATE: 'Please provide a valid date',
  VALID_PHONE: 'Please provide a valid phone number',
};
